import changeIsToastShown from '../actions/changeIsToastShown';
import ReactDOM from 'react-dom';
import setTimerId from '../actions/setTimerId';
import { getToastViewState } from '../store/Store';

export const TOAST_DIV_ID: string = 'MiniToast';

/**
 * Util to hide the toast from the screen
 */
export default function hideToast(toastDivId: string = ''): void {
    const toastId = TOAST_DIV_ID + toastDivId;
    const toastDiv = document.querySelector(`[id^="${toastId}"]`);

    if (toastDiv) {
        removeToastFromDOM(toastDiv);
        clearToastStore();
    }
}

const removeToastFromDOM = (toastDiv: Element) => {
    ReactDOM.unmountComponentAtNode(toastDiv);
    document.body.removeChild(toastDiv);
};

const clearToastStore = () => {
    const store = getToastViewState();

    // Change the state of the store
    store.isToastShown && changeIsToastShown(false);

    // Clear the timer if present
    if (store.timerId) {
        clearTimeout(store.timerId);
        setTimerId(null);
    }
};
